import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36a208b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubFormItemGroup = _resolveComponent("SubFormItemGroup")!
  const _component_uf_form = _resolveComponent("uf-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_uf_form, {
      "show-error": "",
      "scroll-to-error": "",
      "show-error-message": false
    }, {
      default: _withCtx(() => [
        (_ctx.list.length)
          ? (_openBlock(), _createBlock(_component_SubFormItemGroup, {
              key: 0,
              list: _ctx.list,
              id: _ctx.$route.query.id || ''
            }, null, 8, ["list", "id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}